module.exports = __webpack_public_path__ + "static/media/under-maintenance.8fac64b2.png";